import React from 'react';
import { cn } from '../../lib/cn';
import { piPublicCard } from './piPublicClasses';

export interface PiPublicCardProps {
  children: React.ReactNode;
  className?: string;
}

export function PiPublicCard({ children, className }: PiPublicCardProps) {
  return <div className={cn(piPublicCard, className)}>{children}</div>;
}
